import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject, Subject } from 'rxjs';

import { DisplaySetting } from '../models/display-setting';
import { ChatParam } from '../models/chat-param';
import { SkillAvailability } from '../models/skill-availability';

@Injectable({
    providedIn: 'root'
})
export class PreChatService {
    readonly chatParams$ = new BehaviorSubject<ChatParam[]>([]);
    public activeChatData$ = new Subject<any>();
    public invitationAccepted$ = new Subject<boolean>();
    public reactiveFormSubmit$ = new Subject<boolean>();

    constructor(private http: HttpClient) {
        window.addEventListener("message", (event) => {
            this.receiveMessage(event);
        });
    }

    bindToMessageEvents(): Observable<ChatParam[]> {
        return this.chatParams$.asObservable();
    }

    receiveMessage(event) {
        if (!event.data) return;
        switch (event.data.message) {
            case 'uwfSetChatParams':
                let params: ChatParam[] = event.data.params || [];
                this.chatParams$.next(params);
                break;
            case 'uwfInvitationAccepted':
                this.invitationAccepted$.next(event.data.invitationAccepted);
                break;
            case 'uwfActiveChatData':
                this.activeChatData$.next(event.data);
                break;
            case 'uwReactiveFormSubmit':
                this.reactiveFormSubmit$.next(event.data.submit);
                break;
            default:
                console.log('Unknown message received: ' + event.data.message);
        }
    }

    toggleChat(): void {
        parent.postMessage("uwfButtonClick", "*");
    }

    hideChat(): void {
        parent.postMessage("uwfHideChat", "*");
    }

    enableChat(): void {
        parent.postMessage('uwfEnableButton', '*');
    }

    getDefaultSkillAddress() {
        return this.http.get<string>('/api/floatingchat/getdefaultskilladdress');
    }

    getSkillStatus(skillAddresses: string[]) {
        return this.http.post<SkillAvailability[]>('/api/floatingchat/checkskillstatus', {skillAddress: skillAddresses});
    }

    getPreChatForm(lang: string, formTag: string) {
        return this.http.get<any>(`/api/ChatAdminSettings/GetPrechatForm/${lang}/${formTag}`);
    }

    getDisplaySetting(id: number) {
        return this.http.get<DisplaySetting>(`/api/ChatAdminSettings/DisplaySetting/${id}`);
    }

    getTimeZone() {
        return upstream.customerchat.helpers.GetTimeZoneName();
    }

    setFormSubmitted() {
        parent.postMessage('uwfSetFormSubmitted', '*');
    }

    updateChatState() {
        upstream.customerchat.helpers.updateShowChatState();
    }

    showPreChatFormForProactive() {
        parent.postMessage('uwfShowChatForActiveSession', '*');
    }

    sendChatFrameLoadEvent() {
        parent.postMessage("uwfChatFrameLoaded", "*");
    }

    logEvent(logEventCode: number, logEventDescription: string) {
        parent.postMessage({
            message: 'uwfLogEvent',
            eventCode: logEventCode,
            eventDescription: logEventDescription
        }, '*');
    }

    sendProactiveErrorMessage(errorMessage: string) {
        parent.postMessage({message: 'uwfProactiveError', error: errorMessage}, "*");
    }
}
